import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateDistance',
})
export class TranslateDistancePipe
  extends DecimalPipe
  implements PipeTransform {
  constructor(private translateService: TranslateService) {
    super(translateService.currentLang);
  }

  transform(value: number, type: string): string {
    switch (type) {
      case 'kmTruncated':
        return (
          super
            .transform(value, '1.0-0', this.translateService.currentLang)
            .toLocaleString() + ' km'
        );
      case 'kmWithComma':
      default:
        return (
          super
            .transform(value, '1.2-2', this.translateService.currentLang)
            .toLocaleString() + ' km'
        );
    }
  }
}
